import { Component, ChangeDetectionStrategy, Input } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "myqq-modal-header",
  templateUrl: "./modal-header.component.html",
  styleUrls: ["./modal-header.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ModalHeaderComponent {
  @Input()
  showMenu = true;

  constructor(readonly dialogRef: MatDialogRef<unknown>) {}

  close() {
    this.dialogRef.close();
  }
}
